export default {
  data() {
    // 校验输入字数的最大长度
    var maxLength = (rule, value, callback, length) => {
      if (value.length > length) {
        callback(new Error(`最多输入${length}个字`));
      } else {
        callback();
      }
    };
    //上传微视频大小不超过200MB
    var maxSize = (rule, value, callback, length) => {
      if (value > length) {
        callback(new Error(`上传视频大小不能超过${length}MB`));
      } else {
        callback();
      }
    };
    //上传视频时长建议小于2分钟
    var maxVideoLength = (rule, value, callback, length) => {
      if (value > length) {
        callback(new Error(`上传视频时长建议小于${length}秒`));
      } else {
        callback();
      }
    };
    return {
      videoForm: {
        videoName: "",
        videoLink: "",
        videos: [],
        videoLength: 0,
        videoSize: 0,
        coverUrl: "",
        covers: [],
        categoryId: "",
        publisherId: "",
        onlineStatus: 0,
        isDirectOnline: "0"
      },
      rules: {
        videoName: [
          {
            required: true,
            message: "请输入视频名称",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              maxLength(rule, value, callback, 100);
            },
            trigger: "blur"
          }
        ],
        videoLink: [
          {
            required: true,
            message: "请上传视频内容",
            trigger: "change"
          }
        ],
        videoSize: [
          {
            validator: (rule, value, callback) => {
              maxSize(rule, value, callback, 200);
            },
            trigger: "blur"
          }
        ],
        videoLength: [
          {
            validator: (rule, value, callback) => {
              maxVideoLength(rule, value, callback, 120);
            },
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请选择视频分类",
            trigger: ["change", "blur"]
          }
        ],
        publisherId: [
          {
            required: true,
            message: "请选择发布主体",
            trigger: ["change", "blur"]
          }
        ]
      }
    };
  },
  watch: {
    "videoForm.videos": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.videoLink = val[0].url;
          this.videoForm.videoSize = val[0].size;
          //封面为空取视频内容第一帧作为封面
          this.videoForm.coverUrl =
            val[0].url +
            "?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto";
        } else {
          this.videoForm.videoLink = "";
          this.videoForm.videoSize = 0;
        }
      }
    },
    "videoForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.coverUrl = val[0].url;
        } else {
          this.videoForm.coverUrl = "";
        }
      }
    }
  }
};
